import * as React from "react";
import { useFormInstanceField } from "../../../../../store/base";

// store, state
import { constants } from "../../../../../store/managementContracts";
import DetailInfo from "../../../../Details/OverviewInfo/DetailInfo/DetailInfo";
import { OverviewTitleWrapper } from "../../../../Details/OverviewInfo/styles";
import { DateCell, DurationCell } from "../../../../Displays";
import { InnerBox } from "../../../../sharedStyles";
import {
  DatePicker,
  RadioGroup,
  Select,
  TextField,
} from "../../../Base/Fields";

export default ({ method, leaseContract }) => {
  const storeName = constants.STORE_NAME;

  const status = useFormInstanceField({
    storeName,
    fieldKey: "status",
  });

  const infoObj = {
    "Avtalets villkor": [
      {
        title: "Uppsägningstid",
        value: <DurationCell durationStamp={leaseContract?.notify_interval} />,
      },
      {
        title: "Förlägningstid",
        value: <DurationCell durationStamp={leaseContract?.renew_interval} />,
      },
      {
        title: "Slutdatum",
        value: <DateCell data={leaseContract?.end_date} />,
      },
    ],
  };

  return (
    <>
      <DetailInfo infoObj={infoObj} />

      <RadioGroup
        {...{
          storeName,
          method,
          fieldKey: "landlord_cancelled",
          title: "Ange vem som sa upp förvaltningsavtalet",
        }}
        options={[
          { label: "Uppsagt av Hyresvärd", value: true },
          { label: "Uppsagt av Kund ", value: false },
        ]}
        defaultValue={true}
      />

      <Select
        {...{
          storeName,
          method,
          fieldKey: "status",
          title: "Typ av uppsägning",
        }}
        filterChoices={(c) => [6, 7].includes(c.v)}
      />

      <DatePicker
        {...{
          storeName,
          method,
          fieldKey: "closed_on",
          title: "Uppsägningsdatum",
          description: "Ange vilket datum förvaltningsavtalet sas upp",
        }}
      />

      {status === 6 && (
        <DatePicker
          {...{
            storeName,
            method,
            fieldKey: "closed_date",
            title: "Datum för utflytt",
            description: "Ange vilket datum utflytt ska ske",
          }}
        />
      )}
      {status === 7 && (
        <DatePicker
          {...{
            storeName,
            method,
            fieldKey: "closed_renew_date",
            title: "Datum för avtalsändring",
            description:
              "Ange vilket datum det nya förvaltningsavtalet träder i kraft",
          }}
        />
      )}

      <TextField
        {...{
          storeName,
          method,
          fieldKey: "closed_cause",
          title: "Anledning till uppsägning",
        }}
      />
    </>
  );
};
